// test707
(707 && 0);
